export const faqs = [
  {
    question: 'Do I get the complete book and all five bonuses?',
    answer: 'Yes. You get one complete book with 36 classroom lessons organized in six themed units, plus the five bonuses listed above.',
  },
  {
    question: 'Does this work for both younger and older elementary students?',
    answer:
      'Each lesson includes K–2 and grades 3–5 worksheet versions, with age-band teaching adaptations. Select the version that fits your group and adapt for individual needs.',
  },
  {
    question: 'Does “36 weeks” mean 36 lessons for each grade?',
    answer:
      'No. There are 36 lessons total. The planner suggests one lesson per week over 36 weeks. You can use the appropriate adaptations across classes; the bundle does not contain a separate 36-lesson curriculum for every grade.',
  },
  {
    question: 'How much preparation is needed?',
    answer:
      'Read the teaching plan, choose the age-band materials, print the pages and gather the simple supplies listed. The scripts and activities are prepared so you do not have to design the lesson yourself.',
  },
  {
    question: 'Are the materials digital or printed?',
    answer:
      'This is a digital PDF bundle in English. Download the materials and print the pages you need. No books or other physical products are shipped.',
  },
  {
    question: 'Can I use the materials with multiple classes?',
    answer:
      'The license covers one counselor or educator using the resources with their own classes and groups. You may print student materials for those sessions. Sharing the digital files with other staff or across a school is not included.',
  },
  {
    question: 'Is this ASCA-approved or a clinical program?',
    answer:
      'No ASCA approval, endorsement or verified standards alignment is claimed. These are educational classroom resources, not therapy or a substitute for individualized support. The learning checks are educational tools, not diagnostic or validated assessments.',
  },
  {
    question: 'What if it isn’t right for me?',
    answer: 'Request a refund within ten days of purchase using the support contact provided with your order.',
  },
  {
    question: 'Can I buy from outside the United States?',
    answer: 'Yes. You can buy from anywhere in the world. The price is shown in USD and you pay in your local currency.',
  },
];
